import { render, staticRenderFns } from "./OnboardingRules.vue?vue&type=template&id=55375d8f&"
import script from "./OnboardingRules.vue?vue&type=script&lang=js&"
export * from "./OnboardingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports